// extracted by mini-css-extract-plugin
module.exports = {"link":"creditline-module--link--280C4","text":"creditline-module--text--2HtR4"};